import "react-toastify/dist/ReactToastify.css";

import { Amplify } from "aws-amplify";
import { ContextGlobal } from "./context/global";
import GlobalStyle from "./theme/globalStyles";
import MyTheme from "./theme/myTheme";
import Routes from "./routes";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import aws_exports from "./aws-exports";

Amplify.configure(aws_exports);

export default function App() {
    return (
        <>
            <ThemeProvider theme={MyTheme}>
                <GlobalStyle />
                <ContextGlobal>
                    <Routes />
                </ContextGlobal>
                <ToastContainer autoClose={5000} position="top-center" />
            </ThemeProvider>
        </>
    );
}
